<header class="flex-1" [class.showcase]="isShowcase$ | async">
  <div class="flex container">
    <app-main-navigation-trigger />
    <app-breadcrumb class="breadcrumb" />

    <nav class="flex gap-2 end">
      @let isActive = isEmergencyStopActive$ | async;
      @if (showEmergencyStop$ | async) {
        <button
          class="button icon-button danger-outlined-button"
          [disabled]="isActive"
          (click)="onEmergencyStop()"
        >
          <app-text-with-icon name="ic_emergency">{{
            "emergencyStop.label" | translate
          }}</app-text-with-icon>
        </button>
      }
      @if (showHeaderNotification$ | async) {
        <app-header-notification />
      }

      @if (currentUser$ | async; as currentUser) {
        @if (isShowcase$ | async) {
          <button class="flex" (click)="onLogout()">
            <app-profile-image size="demo" />
            <p class="hidden-on-mobile">
              {{ "demo.logoutButton" | translate }}
            </p>
          </button>
        } @else {
          <button
            class="flex"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu"
          >
            <app-profile-image size="header" />
            <p class="hidden-on-mobile">{{ currentUser?.info?.name }}</p>
            <span
              class="button icon-button hidden-on-mobile"
              [class.open]="menuTrigger.menuOpen"
            >
              <app-icon name="ic_chevron_down" />
            </span>
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <div class="flex profile" style="min-width: 200px">
              <app-profile-image />
              <div>
                <p>{{ currentUser?.info?.name }}</p>
                <p>{{ currentUser?.info?.email }}</p>
              </div>
            </div>
            @for (item of menuData; track item.labelKey) {
              <button mat-menu-item (click)="item.action()">
                {{ item.labelKey | translate }}
              </button>
            }
          </mat-menu>
        }
      }
    </nav>
  </div>

  <!--@if (headline) {
    <h1>{{ headline | translate }}</h1>
  }

  @if (description) {
    <p>{{ description | translate }}</p>
}-->
</header>
